import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SmallPlainInsetBtn } from "../buttons";
import ConnectionBtn from "../memberSlider/memberSlider";
import { SkitsOlympicLogoIcon, TrashCanIcon } from "../icons";
import "./skitReviewCard.scss";

export default function SkitReviewCard({
  skit,
  onAction,
  isPlaying, // ← comes from parent
  onPlayToggle, // ← comes from parent
}) {
  const {
    id,
    title,
    mediaUrl,
    skitThumbNailPosterImgUrl: poster,
    reportReasons = [],
    whistleBlownCount = 0,
    User,
    duration: initialDuration = 0,
  } = skit;

  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [duration, setDuration] = useState(initialDuration);

  // 1) When parent’s `isPlaying` changes, play or pause the <video>
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    if (isPlaying) v.play().catch(console.error);
    else v.pause();
  }, [isPlaying]);

  // 2) Capture real duration once metadata loads
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const onMeta = () => setDuration(Math.floor(v.duration));
    v.addEventListener("loadedmetadata", onMeta);
    return () => v.removeEventListener("loadedmetadata", onMeta);
  }, [mediaUrl]);

  // flatten reasons
  const reasonsList = reportReasons
    .flatMap((rr) => rr.reasons.map((r) => r.optionId))
    .join(", ");

  return (
    <div className="skit-review-card">
      {/* video area toggles via parent callback */}
      <div className="video-section-wrapper" onClick={onPlayToggle}>
        <video
          ref={videoRef}
          src={skit.mediaUrl} // ← set your URL here
          poster={skit.skitThumbNailPosterImgUrl}
          preload="metadata"
          playsInline
          controls
          // ...and when they hit native pause, clear it
          onPause={() => {
            // only toggle off if we currently think we're playing
            if (isPlaying) onPlayToggle();
          }}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        >
          {/* no <source> needed when you set src on <video> */}
          Your browser doesn’t support <code>video</code>.
        </video>
        <div className="title-overlay">{title}</div>
      </div>
      {/* controls never mount/unmount, just call onPlayToggle */}
      <div className="video-controls" onClick={(e) => e.stopPropagation()}>
        <ConnectionBtn
          user={User}
          slideBtnText="Viewer Profile"
          onHandleSlideEnd={() => navigate(`/user-profile/${User.id}`)}
          className="profile-btn"
        />
        <div className="report-info">
          <strong>Whistle Blown Count:</strong> {whistleBlownCount}
          {reasonsList && (
            <div>
              <strong>Reasons:</strong> {reasonsList}
            </div>
          )}
        </div>
      </div>
      <div className="action-buttons">
        <SmallPlainInsetBtn
          icon={<SkitsOlympicLogoIcon />}
          text="Go Live"
          onClick={() => onAction(id, "live")}
        />
        <SmallPlainInsetBtn
          icon={<TrashCanIcon />}
          text="Delete"
          onClick={() => onAction(id, "delete")}
        />
      </div>
    </div>
  );
}
